import { Link, createFileRoute, useNavigate } from '@tanstack/react-router';
import { ArrowLeft } from 'lucide-react';
import type { CreateGroupContentInput } from '@news-cms/shared';
import { buttonVariants } from '@/components/ui/button';
import { GroupContentForm } from '@/components/group-contents/group-content-form';
import { SuperAdminFallback } from '@/components/auth/super-admin-fallback';
import { useSession } from '@/lib/auth';
import { useCreateGroupContent } from '@/lib/group-contents';

export const Route = createFileRoute('/_authenticated/group-contents/new')({
  component: NewGroupContentPage,
});

function NewGroupContentPage() {
  const navigate = useNavigate();
  const { user } = useSession();
  const create = useCreateGroupContent();

  const handleSubmit = async (input: CreateGroupContentInput) => {
    try {
      const group = await create.mutateAsync(input);
      await navigate({ to: '/group-contents/$id/edit', params: { id: group.id } });
    } catch {
      // toast surfaced via mutation
    }
  };

  if (!user || user.role.slug !== 'super_admin') return <SuperAdminFallback />;

  return (
    <div className="p-4 sm:p-8">
      <div className="mx-auto max-w-4xl space-y-6">
        <div className="flex items-center gap-3">
          <Link to="/group-contents" className={buttonVariants({ variant: 'ghost', size: 'sm' })}>
            <ArrowLeft className="mr-1 h-4 w-4" /> กลับ
          </Link>
          <h1 className="text-2xl font-bold tracking-tight text-slate-900 dark:text-slate-50">
            สร้าง Group Content
          </h1>
        </div>
        <GroupContentForm mode="create" onSubmit={handleSubmit} isSubmitting={create.isPending} />
      </div>
    </div>
  );
}
